import styled from "styled-components";

export default styled.div`
  width: 70px;
  height: 30px;
  background: rgba(9, 169, 3, 0.7);
  border-radius: 50px;
  padding: 5px 9px;
  cursor: pointer;
  flex-shrink: 0;
`;
